import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";

export interface MailChatPersistentStoreType {
  chatId?: string;
  fromUserId?: string;
  toUserId?: string;
}
export const mailChatPersistentStore = new Store<MailChatPersistentStoreType>(
  persist(
    () => ({
      chatId: undefined,
    }),
    {
      name: storageKey.MAIL_CHAT_STORAGE, // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  ) as any
);

export const mailChatPersistentStoreActions = {
  selectConversation(payload: {
    chatId?: string;
    fromUserId?: string;
    toUserId?: string;
  }) {
    mailChatPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.MAIL_CHAT_STORAGE);
  },
};
